import {
    Ifacility,
    IinstallBase,
    Ibuilding,
    Ifloor,
    Ilocation,
    Iroom,
    IinstallBasePopulated,
    IjobPopulated,
    IdashboardItem,
    IjobHour,
    IfacilityContact,
    IWorkOrder,
    IinstallBasePartPopulated,
    IsuggestedPartPopulated,
    Iphoto
} from '../../models';
import find from 'lodash/find';
import map from 'lodash/map';

import { Column } from 'react-table';
import { TFunction } from 'i18next';

type ColumnUnionType =
    | Column<IinstallBasePopulated>
    | Column<IjobPopulated>
    | Column<IdashboardItem>
    | Column<IjobHour>
    | Column<IfacilityContact>
    | Column<IWorkOrder>
    | Column<IinstallBasePartPopulated>
    | Column<IsuggestedPartPopulated>
    | Column<Iphoto>;

export const TableUtil = {
    translateHeaders: (columns: ColumnUnionType[], t: TFunction) => {
        return map(columns, column => {
            if (column.Header && typeof column.Header === 'string') {
                return { ...column, Header: t(column.Header) };
            }

            return column;
        });
    },
    /*
     * take the install and find the names for the location id's.  building, floor, locations, rooms, position
     */
    buildLocation: (install: IinstallBase, facility: Ifacility) => {
        let locationString = '';
        const building = find(facility.buildings, {
            id: install.buildingID
        }) as Ibuilding | undefined;

        if (building) {
            locationString += building.name;
            const floor = find(building.floors, { id: install.floorID }) as Ifloor | undefined;
            if (floor) {
                locationString += `: ${floor.name}`;
                const location = find(floor.locations, {
                    id: install.locationID
                }) as Ilocation | undefined;
                if (location) {
                    locationString += `: ${location.name}`;
                    const room = find(location.rooms, { id: install.roomID }) as Iroom | undefined;
                    if (room) {
                        locationString += `: ${room.name}`;
                    }
                }
            }
        }
        if (install.position) {
            locationString += `: ${install.position}`;
        }
        return locationString;
    }
};
